<template>
  <message-template :direction="direction" :time="time" :image="image" :channel="channel">
    <div
      class="log-text-message-block message-bg"
      :class="{
        'incoming': direction === 'incoming',
        'outgoing': direction === 'outgoing',
        'manual': isManual
      }"
    >
      <span v-if="data.answers && data.answers[0]">{{data.answers[0].text}}</span>
      <span v-else-if="data.text">{{data.text}}</span>
      <span v-else>
        <strong>Wrong text message format</strong>
        <br />
        {{data}}
      </span>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'textMessage',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    direction: {
      type: String,
      default: '',
    },
    time: [String, Number],
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
    image: {
      type: String,
      default: '',
    },
    isManual: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.log-text-message-block {
  background-color: #efefef;
  padding: 10px;
  display: inline-block;
  &.manual {
    background-color: #fff;
    border: 1px solid #39a1bd;
  }
  &.incoming {
    border-radius: 0 10px 10px 10px;
  }
  &.outgoing {
    text-align: left;
    border-radius: 10px 0 10px 10px;
  }
}
</style>
